import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Append a stable cache-busting query param to a URL.
 * Returns the URL unchanged when url or key is missing.
 */
export function withCacheBust(url: string | null | undefined, key: string | number | null | undefined): string | undefined {
  if (!url) return url ?? undefined;
  if (key === null || key === undefined || key === "") return url;
  const v = encodeURIComponent(String(key));
  // Signed URLs (S3 v4 etc.) reject extra query params — appending `?v=` would
  // break the signature and the image fails to load. Use a fragment instead,
  // which the server never sees but still changes the React `src` string so
  // the element re-renders when `modified` changes.
  if (url.includes("?")) {
    const [base, frag] = url.split("#", 2);
    // Replace any existing #v=... fragment we added previously.
    void frag;
    return `${base}#v=${v}`;
  }
  return `${url}?v=${v}`;
}
